import { render, staticRenderFns } from "./o-site-footer-v2.vue?vue&type=template&id=5ff4499c&scoped=true"
import script from "./o-site-footer-v2.vue?vue&type=script&lang=js"
export * from "./o-site-footer-v2.vue?vue&type=script&lang=js"
import style0 from "./o-site-footer-v2.vue?vue&type=style&index=0&id=5ff4499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4499c",
  null
  
)

export default component.exports